import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "font-awesome/css/font-awesome.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import aboutone from "../assets/img/about/1.png";
import abouttwo from "../assets/img/about/2.png";
import iconsone from "../assets/img/icons/1.png";
import iconstwo from "../assets/img/icons/2.png";
import iconsthree from "../assets/img/icons/3.png";
import { Helmet } from "react-helmet-async";
import iconsfour from "../assets/img/icons/4.png";

const About = () => {
  const counterRef = useRef(null);

  useEffect(() => {
    const startCounter = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.querySelectorAll(".count-number").forEach((counter) => {
            let target = +counter.getAttribute("data-to");
            let speed = +counter.getAttribute("data-speed");
            let count = 0;
            let increment = target / speed * 15; // Smooth animation speed

            let updateCount = () => {
              if (count < target) {
                count += increment;
                counter.innerText = Math.ceil(count);
                setTimeout(updateCount, 15);
              } else {
                counter.innerText = target;
              }
            };

            updateCount();
          });

          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(startCounter, { threshold: 0.5 });
    if (counterRef.current) observer.observe(counterRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <>
    {/* Page Title */}
    <Helmet>
        <title>About Us || JI IMPEX</title>
      </Helmet>
      {/* Page Header */}
      <div className="container-fluid about-page page-header py-5 mb-5 wow fadeIn">
        <div className="container text-center py-5">
          <h1 className="display-4 text-white animated slideInDown mb-4">About Us</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a className="text-white" href="/">Home</a>
              </li>
              <li className="breadcrumb-item text-primary active" aria-current="page">About</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* <!-- About Start --> */}
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="position-relative overflow-hidden ps-5 pt-5 h-100" style={{ minHeight: '400px' }}>
                <img class="position-absolute w-100 h-100" src={aboutone} alt="" style={{ objectFit: 'cover' }} />
                <div class="position-absolute top-0 start-0 bg-white pe-3 pb-3" style={{ width: '200px', height: '200px' }}>
                  <div class="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 class="text-white">30</h1>
                    <h2 class="text-white">Years</h2>
                    <h5 class="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="h-100">
                <div class="border-start border-5 border-primary ps-4 mb-5">
                  <h6 class="text-body text-uppercase mb-2">About Us</h6>
                  <h1 class="display-6 mb-0">Marine Spare Parts, Equipments, and Industrial Automation all at one place.</h1>
                </div>
                <p>J.I.IMPEX is a leading supplier of new, used and refurbished ship spares and machinery.If you are looking for quality marine equipment, then we can provide you the best ship machinery.</p>
                <p class="mb-4">At J.I.IMPEX, we specialize in sourcing new surplus and second-hand machinery and equipment from Asia’s largest Ship Recycling Yard – Alang (India). Our rigorous inspection and refurbishing procedures ensure that all our products meet the highest quality standards before being sold to traders and end-users.</p>
                <div class="border-top mt-4 pt-4">
                  <div class="row g-4">
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.1s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Reasonable & Competitive Price</h6>
                    </div>
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.3s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Quick Communication</h6>
                    </div>
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.5s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Fast Delivery</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}

      {/* <!-- Features Start --> */}
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="border-start border-5 border-primary ps-4 mb-5">
                <h6 class="text-body text-uppercase mb-2">Why Choose Us!</h6>
                <h1 class="display-6 mb-0">We are J.I.Impex</h1>
              </div>
              <p class="mb-5" style={{ textTransform: 'capitalize' }}>We are a team of maritime professional including engineers and sales experts, who work 24 * 7 * 365, to make sure our client ships keep working. We supply spares with working guarantee and after sale support. </p>
              <div class="row gy-5 gx-4">
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsone} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>ADVANCED TECHNOLOGY</h6>
                  </div>
                  <span>Our workshop is equipped with advance technology to repair and refurbish major spares , with the lest required time.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconstwo} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>DELIVERY ON TIME</h6>
                  </div>
                  <span>Time is the most valuable asset in Marine industry. We maintain a track record of supplying our spares within 24 hrs of receiving order confirmation.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsthree} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>CERTIFIED PRODUCTS</h6>
                  </div>
                  <span>Our products is 100% genuine and well certified by our experienced experts, and we delivered products with best rates.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsfour} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>BEST SERVICES</h6>
                  </div>
                  <span>We Provide Services like Class Survey, MPI & Hardness Test, Sandblasting, Repainting and other Services.</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="position-relative overflow-hidden ps-5 pt-5 h-100" style={{ minHeight: '400px' }}>
                <img class="position-absolute w-100 h-100" src={abouttwo} alt="" style={{ objectFit: 'cover' }} />
                <div class="position-absolute top-0 start-0 bg-white pe-3 pb-3" style={{ width: '200px', height: '200px' }}>
                  <div class="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 class="text-white">30</h1>
                    <h2 class="text-white">Years</h2>
                    <h5 class="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Features End --> */}

      {/* Counter Section */}
      <div className="container-fluid counter py-5" id="num-counter" ref={counterRef}>
        <div className="container py-5">
          <div className="row g-4 counter-area-div">
            {[
              { icon: "fa-check", number: 456, text: "Completed Projects" },
              { icon: "fa-users", number: 513, text: "Happy Customers" },
              { icon: "fa-user", number: 53, text: "Qualified Engineers" },
              { icon: "fa-thumbs-up", number: 30, text: "Years Experience" },
            ].map((item, index) => (
              <div key={index} className="col-lg-6 col-xl-3 counter">
                <i className={`fa ${item.icon} fa-2x`}></i>
                <h2 className="timer count-title count-number" data-to={item.number} data-speed="1500">0</h2>
                <p className="count-text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
